/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { validate as validateJson } from 'json-schema';

import { schema } from '../schema/pg-config.schema';
import { Config } from '../schema/pg-config.types';

export const validate = (config: Config, renderedSchema: typeof schema) => validateJson(config, renderedSchema);
